import { render } from "./CopilotPage.vue?vue&type=template&id=2f0d1b78&scoped=true"
import script from "./CopilotPage.vue?vue&type=script&lang=js"
export * from "./CopilotPage.vue?vue&type=script&lang=js"

import "./CopilotPage.vue?vue&type=style&index=0&id=2f0d1b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0d1b78"]])

export default __exports__